import React from 'react'
import logo from '../images//cocard_member_office_logo.png';
import Contact from './modals/Contact'
import $ from 'jquery'

export default function Footer() {
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const openModal = (e) => {
        e.preventDefault();
        setIsOpen(true);
        setTimeout(() => {
            handleTab(e.target.name);
            $('#contactModal').modal('show');
        }, 150);
    }
    const handleTab = (tab) => {
        if (!$('#contactModal #callEmail').hasClass('active')) {
            $(`#contactModal #callEmail`).removeClass('active show');
            $(`#contactModal #callEmail-tab`).removeClass('active');
        }
        $(`#contactModal #${tab}`).addClass('active show');
        $(`#contactModal #${tab}-tab`).addClass('active');
            if (localStorage.getItem('oldTab') != null && localStorage.getItem('oldTab') !== tab) {
                $(`#contactModal #${localStorage.getItem('oldTab')}`).removeClass('active show');
                $(`#contactModal #${localStorage.getItem('oldTab')}-tab`).removeClass('active');
            }
        localStorage.setItem('oldTab', tab);
    }
    const year = () => { return new Date().getFullYear(); }
    return (
        <footer className="mt-5">
            <div className="container">
                <div className="top">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-md-4">
                            <a href="https://cocardpayments.com/"><img src={logo} className="logo" alt="CoCard Logo" /></a>
                        </div>
                        <div className="col-md-8">
                            <ul className="footer-links">
                                {/* <li><a href="https://cocardpayments.com/inner.html?smooth=fees">Cash Discount</a></li>
                                <li><a href="https://cocardpayments.com/inner.html?smooth=in_person">In-Store</a></li>
                                <li><a href="https://cocardpayments.com/inner.html?smooth=online_simple">Online</a></li>
                                <li><a href="https://cocardpayments.com/inner.html?smooth=mobile_go">Mobile</a></li> */}
                                <li><a className="contact" href="#" name={'callEmail'} onClick={(e) => openModal(e)}>Contact Us</a></li>
                                <li><a className="contact" href="#" name={'askQuestion'} onClick={(e) => openModal(e)}>Ask a Question</a></li>
                                <li><a className="contact" href="#" name={'requestCallback'} onClick={(e) => openModal(e)}>Request a Call Back</a></li>
                                <li><a className="contact" href="#" name={'faq'} onClick={(e) => openModal(e)}>FAQ</a></li></ul>
                        </div>
                    </div>
                </div>
                <p style={{"fontSize": "10px"}}>* Offer available for a limited time. Limit of one (1) Clover POS System, or credit card terminal or mobile card reader for the advertised price. Offer subject to change without notice. Offer only valid for new customers. Must open a merchant account through CoCard Business. Terms & Conditions apply. Offer only valid with minimum processing requirements. Minimum processing requirements are as follows: to qualify for discounted price and/or equipment placement merchant must show a combined monthly processing volumes of at least $15,000 per month on 2 consecutive months of past merchant processing statements within the past 18 months. Seasonal businesses do not qualify for special equipment pricing. All equipment sales are final with no returns or exchanges permitted. Please ask your sales agent for complete program details. To stop receiving text messages you can text any of these commands: Stop, Cancel, Quit, Unsubscribe, End. Text HELP for help. Message and data rates may apply. Message frequency varies. And to stop receiving email messages please click the email's unsubscribe link. All calls may be recorded.</p>
                <div className="row justify-content-center text-center">
                    <div className="col-12">
                        <p className="mb-0">©{year()} CoCard | CoCard<sup>®</sup> is a registered ISO of Wells Fargo Bank, N.A., Concord, CA.</p>
                        <p className="mb-0">CoCard<sup>®</sup> is a registered ISO of Citizens Bank, N.A., Providence, RI. CoCard<sup>®</sup> is a registered ISO of Fifth Third Bank, N.A. 38 Fountain Square Plaza, Cincinnati, OH 45263</p>
                    </div>
                </div>
            </div>
            {modalIsOpen ?
                <Contact />
                : ''}
        </footer>
    )
}
